export default "__VITE_ASSET__0Gvn2mhA__"